<template>
  <div v-loading="isLoading" class="basic-ads-campaigns-stats-install-box">
    <header class="basic-ads-campaigns-stats-install-box__header">
      <img
        :src="require('@/assets/images/target.svg')"
        class="basic-ads-campaigns-stats-install-box__header-image"
      />
    </header>
    <div class="row">
      <div class="columns large-‌5">
        <div class="basic-ads-campaigns-stats-install-box__stats-title">
          {{ $t('ADVERTISEMENT.CAMPAIGNS.BASIC_ADS_INSTALL_STATS') }}
        </div>
        <div class="basic-ads-campaigns-stats-install-box__stats-value">
          {{ formattedTotalInstall }} {{ $t('INSTALL') }}
        </div>
      </div>
      <div class="columns large-7">
        <div class="basic-ads-campaigns-stats-install-box__stats-title">
          {{ $t('ADVERTISEMENT.CAMPAIGNS.BASIC_ADS_AVERAGE_INSTALL_STATS') }}
        </div>
        <div class="basic-ads-campaigns-stats-install-box__stats-value">
          {{ formattedAverageDailyInstall }} {{ $t('INSTALL') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from '@/utils/number';

export default {
  name: 'CampaignStatsOverallReportsInstall',

  props: {
    isLoading: Boolean,
    totalInstall: {
      type: Number,
      required: true,
    },
    averageDailyInstall: {
      type: Number,
      required: true,
    },
  },

  computed: {
    formattedTotalInstall() {
      return format(this.totalInstall);
    },
    formattedAverageDailyInstall() {
      return format(Math.round(this.averageDailyInstall));
    },
  },
};
</script>

<style lang="scss">
.basic-ads-campaigns-stats-install-box {
  width: 100%;
  background-color: #fff;

  border: 1px solid $lb-light-gray;
  border-radius: $lb-border-radius * 5;
  padding: $global-padding * 2;

  background-repeat: no-repeat;
  background-position: -12% top;

  @include rtl() {
    background-position: right top;
  }

  &__header {
    margin-bottom: $global-margin * 1.5;
  }

  &__stats {
    &-value {
      font-weight: bold;
      font-size: rem-calc(20px);
      margin-top: $global-margin * 0.25;
    }
  }
}
</style>
